/* ==========================================================================
   GLOBAL — sticky header, drawer, sepet AJAX, predictive search,
            giriş animasyonu, görsel fallback, FAQ akordeonu
   Vanilla JS. Framework yok.

   Temel kural: İÇERİK JS'İN ARKASINA SAKLANMAZ. Script hiç çalışmazsa sayfa
   tam görünür kalır — animasyonlar .js sınıfına bağlı, formlar normal POST/GET
   olarak çalışır, <details> akordeonu JS'siz açılır.

   Sepet istekleri SIRAYA ALINIR: hızlı ardışık tıklamada yanıtlar birbirini
   ezmesin diye tek bir promise zinciri üzerinden gider.
   ========================================================================== */

(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- Sticky header
     Hero üstünde şeffaf; 60px kaydırınca yeşile döner ve duyuru kapanır.
     rAF ile throttle — scroll her frame'de bir kez okunur. */

  /* .site-head sınıfı section'ın SARMALAYICISINA schema'daki "class" ile
     verilir — Shopify her section'ı kendi div'ine sarar, duyuru çubuğu ve
     header'ın tek bir sabit kapsayıcıda olması için sınıf orada durmalı. */
  var head = document.querySelector('.site-head');
  var ticking = false;

  function onScroll() {
    if (!head) return;
    head.classList.toggle('is-solid', window.scrollY > 60);
  }

  if (head) {
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
    }, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------------------------- Drawer */

  var Drawer = {
    active: null,
    lastFocus: null,

    open: function (name) {
      var el = document.querySelector('[data-drawer="' + name + '"]');
      if (!el) return;
      Drawer.lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-drawer-open');
      Drawer.active = el;

      var focusable = el.querySelector('input, button, a[href]');
      if (focusable) window.setTimeout(function () { focusable.focus(); }, 60);
    },

    close: function () {
      if (!Drawer.active) return;
      Drawer.active.classList.remove('is-open');
      Drawer.active.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-drawer-open');
      Drawer.active = null;
      if (Drawer.lastFocus) Drawer.lastFocus.focus();
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      Drawer.open(opener.getAttribute('data-open-drawer'));
      return;
    }
    if (e.target.closest('[data-close-drawer]')) {
      e.preventDefault();
      Drawer.close();
      return;
    }
    /* Drawer içindeki bir bağlantıya tıklanınca kapat — aynı sayfadaki çapa
       linkleri "çalışmıyor" gibi görünmesin */
    if (Drawer.active && e.target.closest('.mobile-nav__link')) {
      Drawer.close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Drawer.close();
  });

  /* ------------------------------------------------------- Açılır alt menü */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-submenu-toggle]');
    var openMenus = document.querySelectorAll('[data-submenu-toggle][aria-expanded="true"]');
    var i;

    if (!toggle) {
      for (i = 0; i < openMenus.length; i++) closeSubmenu(openMenus[i]);
      return;
    }

    e.preventDefault();
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    for (i = 0; i < openMenus.length; i++) closeSubmenu(openMenus[i]);
    if (!isOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      var panel = toggle.parentElement.querySelector('.submenu');
      if (panel) panel.hidden = false;
    }
  });

  function closeSubmenu(toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    var panel = toggle.parentElement.querySelector('.submenu');
    if (panel) panel.hidden = true;
  }

  /* ------------------------------------------------------------------ Sepet */

  var Cart = {
    queue: Promise.resolve(),

    /* Tüm sepet istekleri buradan geçer — sıralı çalışır, ara durum kaybolmaz */
    enqueue: function (task) {
      Cart.queue = Cart.queue.then(task).catch(function (err) {
        Cart.showError(err && err.message ? err.message : strings.add_to_cart_error);
      });
      return Cart.queue;
    },

    request: function (url, body) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            /* 422: stok tükendi / geçersiz adet. Shopify description döner. */
            var message = data.description || data.message || strings.add_to_cart_error;
            throw new Error(message);
          }
          return data;
        });
      });
    },

    render: function (data) {
      if (!data || !data.sections || !data.sections['cart-drawer']) return;

      var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var fresh = parsed.querySelector('[data-cart-section]');
      var current = document.querySelector('[data-cart-section]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;

      var countEl = document.querySelector('[data-cart-count-value]');
      var badges = document.querySelectorAll('[data-cart-count]');
      if (countEl && badges.length) {
        var count = parseInt(countEl.getAttribute('data-cart-count-value'), 10) || 0;
        for (var i = 0; i < badges.length; i++) {
          badges[i].textContent = count;
          badges[i].hidden = count === 0;
        }
      }

      /* Yeni gelen HTML'deki görselleri de işaretle */
      sweepImages();
    },

    /* Hata ÖNCE ürün formuna yazılır, sonra sepete.
       Tersi yapılırsa (sepet önce) "sepete ekle"de çıkan hata kapalı
       drawer'ın içine yazılıyor; müşteri butona basıyor, hiçbir şey olmuyor
       gibi görünüyor ve hatayı ancak sepeti açınca — hem de boş sepetin
       üstünde — görüyor. */
    showError: function (message) {
      var formError = document.querySelector('[data-product-form-error]');
      if (formError) {
        formError.textContent = message;
        formError.hidden = false;
        formError.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var target = document.querySelector('[data-cart-error]');
      if (target) {
        target.textContent = message;
        target.hidden = false;
      }
    },

    clearError: function () {
      var nodes = document.querySelectorAll('[data-cart-error], [data-product-form-error]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = '';
        nodes[i].hidden = true;
      }
    }
  };

  /* Sepete ekle */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-form');
    if (!form) return;

    e.preventDefault();
    Cart.clearError();

    var button = form.querySelector('[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) return;

    if (button) button.disabled = true;

    Cart.enqueue(function () {
      return Cart.request(routes.cart_add_url + '.js', {
        items: [{ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) }]
      }).then(function (data) {
        Cart.render(data);
        Drawer.open('cart');
      }).finally(function () {
        if (button) button.disabled = false;
      });
    });
  });

  /* Sepette adet değiştir / kaldır */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;

    e.preventDefault();
    Cart.clearError();

    var line = btn.getAttribute('data-line');
    var quantity = Number(btn.getAttribute('data-cart-change'));
    var row = btn.closest('[data-cart-item]');
    if (row) row.classList.add('is-busy');

    Cart.enqueue(function () {
      return Cart.request(routes.cart_change_url + '.js', {
        line: Number(line),
        quantity: quantity
      }).then(function (data) {
        Cart.render(data);
      });
    });
  });

  /* Adet input'u (+/- butonları) */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;

    e.preventDefault();
    var wrap = step.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;

    var min = Number(input.getAttribute('min') || 1);
    var next = Number(input.value) + Number(step.getAttribute('data-qty-step'));
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------ Predictive search */

  var search = { controller: null, timer: null };

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-search-input]');
    if (!input) return;

    var results = document.querySelector('[data-search-results]');
    if (!results) return;

    var term = input.value.trim();

    window.clearTimeout(search.timer);
    if (search.controller) search.controller.abort();

    if (term.length < 2) {
      results.innerHTML = '';
      return;
    }

    search.timer = window.setTimeout(function () {
      search.controller = new AbortController();

      var url = routes.predictive_search_url +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&section_id=predictive-search';

      fetch(url, { signal: search.controller.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-search-payload]');
          results.innerHTML = fresh ? fresh.innerHTML : '';
          sweepImages();
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') results.innerHTML = '';
        });
    }, 250);
  });

  /* ---------------------------------------------------- Koleksiyon filtresi
     Filtre veya sıralama değişince formu gönder — GET, sayfa yenilenir.
     JS yoksa noscript'teki "Apply" butonu aynı işi görür. */

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facets]');
    if (!form) return;
    form.submit();
  });

  /* ------------------------------------------------------------ Görsel durumu
     Yüklendiyse placeholder etiketini gizle, yüklenemediyse görseli kaldır ve
     ceviz dokusunu bırak. Kırık ikon veya boş delik hiçbir durumda çıkmaz.
     load/error bubble etmediği için capture fazında dinlenir. */

  function markMedia(img, ok) {
    var media = img.closest('.media');
    if (!media) return;
    media.classList.add(ok ? 'is-loaded' : 'is-broken');
  }

  document.addEventListener('load', function (e) {
    if (e.target.tagName === 'IMG') markMedia(e.target, true);
  }, true);

  document.addEventListener('error', function (e) {
    if (e.target.tagName === 'IMG') markMedia(e.target, false);
  }, true);

  function sweepImages() {
    var imgs = document.querySelectorAll('.media > img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) continue;
      markMedia(imgs[i], imgs[i].naturalWidth > 0);
    }
  }

  /* -------------------------------------------------------- Giriş animasyonu */

  function initReveal() {
    var items = document.querySelectorAll('[data-reveal], [data-reveal-children]');
    if (!items.length) return;

    /* Tema editöründe kapalı — yarım kalmış animasyon merchant'a bozuk görünür */
    if (theme.designMode || reduceMotion || !('IntersectionObserver' in window)) {
      showAll(items);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    for (var i = 0; i < items.length; i++) {
      if (items[i].getBoundingClientRect().top < window.innerHeight) {
        items[i].classList.add('is-revealed');
      } else {
        observer.observe(items[i]);
      }
    }

    /* Güvenlik ağı: 3 saniye sonra ne olursa olsun her şey görünür */
    window.setTimeout(function () { showAll(items); }, 3000);
  }

  function showAll(items) {
    for (var i = 0; i < items.length; i++) items[i].classList.add('is-revealed');
  }

  /* ---------------------------------------------------------- FAQ akordeonu
     <details> zaten JS'siz çalışır. Buradaki tek iş: bir soru açılınca
     diğerlerini kapatmak. */

  function initFaq() {
    var items = document.querySelectorAll('.faq__item');
    if (items.length < 2) return;

    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-faq-bound') === 'true') continue;
      items[i].setAttribute('data-faq-bound', 'true');
      items[i].addEventListener('toggle', function () {
        if (!this.open) return;
        for (var j = 0; j < items.length; j++) {
          if (items[j] !== this) items[j].open = false;
        }
      });
    }
  }

  /* ---------------------------------------------------------------- Öneriler
     Shopify Product Recommendations API. Öneri gelmezse bölüm boş kalır,
     sayfa bozulmaz. */

  function initRecommendations() {
    var holder = document.querySelector('[data-recommendations]');
    if (!holder) return;
    if (holder.getAttribute('data-loaded') === 'true') return;

    var url = holder.getAttribute('data-url');
    if (!url) return;

    holder.setAttribute('data-loaded', 'true');

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh) holder.innerHTML = fresh.innerHTML;
        sweepImages();
        initReveal();
      })
      .catch(function () { /* sessiz geç */ });
  }

  function init() {
    sweepImages();
    initReveal();
    initFaq();
    initRecommendations();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* Tema editöründe section yeniden yüklendiğinde tekrar bağla */
  document.addEventListener('shopify:section:load', init);
})();
